<script setup>
import { watch } from "vue";
import { useForm } from "@inertiajs/vue3";
import { useModalogStore } from "@/stores/modalog";
import BrandConfirmModalog from "@/Components/Modalogs/BrandConfirmModalog.vue";

const modalogStore = useModalogStore();

const vFocus = {
    mounted: (el) => el.focus(),
};

const form = useForm({
    feedback: "",
});

// The host keeps this instance mounted between opens (stable-root
// pattern), so the feedback field re-seeds on every open (GH-955).
watch(
    () => modalogStore.hasModalog,
    (isOpen) => {
        if (isOpen) {
            form.reset();
        }
    },
);

const submit = () => {
    form.delete(route("profile.delete_account"), {
        preserveScroll: true,
        preserveState: true,
        onSuccess: () => {
            alert(
                "Your Gift Hero account was successfully deleted. We are sorry to see you go. You will be redirected to the homepage.",
            );
        },
        onFinish: () => {
            form.reset();
            modalogStore.closeModalog();
        },
    });
};
</script>

<template>
    <BrandConfirmModalog
        title="Confirm Account Deletion"
        confirm-label="Delete My Account"
        busy-label="Deleting Account"
        danger
        :busy="form.processing"
        @confirm="submit"
    >
        <ul
            v-if="Object.keys($page.props.errors ?? {}).length"
            class="mb-4 text-[14px] font-semibold text-brand-red"
        >
            <li v-for="(error, key) in $page.props.errors" :key="key">
                {{ error }}
            </li>
        </ul>
        <p>
            Before you go, please let us know why you are deleting your account.
        </p>
        <div class="mt-4">
            <label
                class="mb-1.5 block text-[15px] font-bold text-[#3c3938]"
                for="feedback"
                >Comments (optional)</label
            >
            <textarea
                id="feedback"
                name="feedback"
                rows="4"
                v-model="form.feedback"
                v-focus
                class="w-full rounded-[5px] border border-solid border-[#a79e9b] bg-white px-4 py-3 font-brand text-[15px] text-brand-navy focus:border-brand-navy focus:outline-none"
            ></textarea>
        </div>
    </BrandConfirmModalog>
</template>
